import { lazy } from 'react'

export const FastingV1 = lazy(() => import('./v1/FastingV1'))
export const FastingV2 = lazy(() => import('./v2/FastingV2'))
